<base-page [title]="'categories.listCategoriesPageTitle' | translate">
    <ng-container page-body>
        <div class="card">
			<div class="card-header">
				<div class="row">
					<div class="col-6">
						<span class="badge badge-success">{{numberOfAvailableItems}}</span> {{'categories.listCategoriesPageCardHeaderTitle' | translate}}
					</div>
					<div class="col-6 text-right">
						<button type="button" (click)="addEntity()"  [enabled-by-permission]="'categories.write'" class="btn btn-primary"><i class="{{iconAdd}}"></i> {{'categories.addNewCategoryButtonLabel' | translate}}</button>
					</div>
				</div>
            </div>
            <div class="card-content">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12">
                            <data-table [columns]="tableColumns" [manager]="dataTableManager" [actions]="tableActions">
                            </data-table>
                        </div>
                    </div>
                </div>
				
            </div>
        </div>
    </ng-container>
</base-page>